import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

import { forgotPassword } from '@/features/auth/api';

export const useForgotPasswordMutation = () => {
  const router = useRouter();

  return useMutation({
    mutationFn: forgotPassword,
    onSuccess: () => {
      toast.success('Password reset request successful!');

      setTimeout(() => {
        router.push('/', { scroll: true });
      }, 5000);
    },
    onError: () => {
      toast.error('Password reset request failed!, Please try again');
    },
  });
};
